import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, Home, User } from 'lucide-react';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-4">
      <div className="bg-zinc-900 rounded-2xl p-8 border border-zinc-800 text-center max-w-md">
        <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-emerald-500" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-3">Payment Successful!</h1>
        <p className="text-zinc-400 mb-8">
          Your membership has been activated. You can now enjoy all premium features.
        </p>
        <div className="space-y-3">
          <Button onClick={() => navigate('/profile')} className="w-full bg-emerald-600 hover:bg-emerald-700">
            <User className="w-4 h-4 mr-2" /> Go to Profile
          </Button>
          <Button onClick={() => navigate('/')} variant="outline" className="w-full border-zinc-700 text-zinc-300 hover:bg-zinc-800">
            <Home className="w-4 h-4 mr-2" /> Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
